import * as React from 'react';
import bindAllOfThis from "src/utils/BindThisHelper";
import PhaserGameComponent from 'src/games/shared/phaserHelpers/PhaserGameComponent';
import { GameIntroScene } from 'src/games/SeekAndFindGame/scenes/GameIntro';

interface PhaserSeekAndFindGameProps {
    onComplete: () => void;
}

interface PhaserSeekAndFindGameState {
}

const gameConfig: GameConfig = {
    title: "Seek and Find Game",
    version: "0.2",
    backgroundColor: "#000000",
};

class PhaserSeekAndFindGame extends React.Component<PhaserSeekAndFindGameProps, PhaserSeekAndFindGameState> {
    private game: Phaser.Game;
    constructor(props: PhaserSeekAndFindGameProps) {
        super(props);
        bindAllOfThis(this, PhaserSeekAndFindGame.prototype);
    }

    render() {
        return (<div>
            <PhaserGameComponent scenes={GameIntroScene} config={gameConfig} onComplete={this.props.onComplete} />
        </div>);
    }
}

export default PhaserSeekAndFindGame;



// WEBPACK FOOTER //
// ./src/games/SeekAndFindGame/Main.tsx